
    import './styles.scoped.css';
    export default {
  "block-body-scroll": "awsui_block-body-scroll_19d8l_xp2g1_3",
  "mobile-bar": "awsui_mobile-bar_19d8l_xp2g1_7",
  "mobile-bar-refresh": "awsui_mobile-bar-refresh_19d8l_xp2g1_19",
  "mobile-bar-breadcrumbs": "awsui_mobile-bar-breadcrumbs_19d8l_xp2g1_23",
  "mobile-toggle": "awsui_mobile-toggle_19d8l_xp2g1_32",
  "mobile-toggle-refresh": "awsui_mobile-toggle-refresh_19d8l_xp2g1_38"
};
  